/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Next-step recommendation attached to a subsystem result.
 * @export
 * @interface ShadowSubsystemAction
 */
export interface ShadowSubsystemAction {
}

/**
 * Check if a given object implements the ShadowSubsystemAction interface.
 */
export function instanceOfShadowSubsystemAction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShadowSubsystemActionFromJSON(json: any): ShadowSubsystemAction {
    return ShadowSubsystemActionFromJSONTyped(json, false);
}

export function ShadowSubsystemActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemAction {
    return json;
}

export function ShadowSubsystemActionToJSON(value?: ShadowSubsystemAction | null): any {
    return value;
}

